module.exports = {
  window: "undefined" == typeof window ? global : window,
  global: "undefined" == typeof global ? window : global,
  document: "undefined" == typeof document ? {} : document
};